import React, { useRef } from "react";
import { useNavigate } from "react-router";
import ArrowDown from "assets/icons/arrow-down.svg";
import {
  MegaMenuTrigger,
  MegaMenuPanel,
  MegaMenuItem,
  MegaMenuItemTitle,
  MegaMenuSubItem,
} from "./megaMenu.styles";
import { NavItem } from "utils/menu-mapper";

interface MegaMenuProps {
  items: NavItem[];
  isActive: boolean;
  onToggle: () => void;
  onClose: () => void;
}

export const MegaMenuComponent: React.FC<MegaMenuProps> = ({
  items,
  isActive,
  onToggle,
  onClose,
}) => {
  const navigate = useNavigate();
  const panelRef = useRef<HTMLDivElement>(null);

  const handleItemClick = (route: string, isExternal?: boolean) => {
    if (isExternal) {
      window.open(route, '_blank', 'noopener,noreferrer');
    } else {
      navigate(route);
    }
    onClose();
  };

  return (
    <MegaMenuTrigger $isActive={isActive} onClick={onToggle}>
      Mais <img src={ArrowDown} alt="Menu" />
      {isActive && (
        <MegaMenuPanel
          ref={panelRef}
          onClick={(e) => e.stopPropagation()}
        >
          {items.map((item, index) => (
            <MegaMenuItem key={`mega-${index}`}>
              <MegaMenuItemTitle onClick={() => handleItemClick(item.route, item.isExternal)}>
                {item.label}
              </MegaMenuItemTitle>
              {item.items && item.items.map((subItem, subIndex) => (
                <MegaMenuSubItem
                  key={`mega-sub-${index}-${subIndex}`}
                  onClick={() => handleItemClick(subItem.route, subItem.isExternal)}
                >
                  {subItem.label}
                </MegaMenuSubItem>
              ))}
            </MegaMenuItem>
          ))}
        </MegaMenuPanel>
      )}
    </MegaMenuTrigger>
  );
};
